import { TableField, defaultCPFFormatter, defaultDateFormatter } from "../../table-field";

export const fieldsPrestacaoContasLRFCI: TableField[] = [
  {
    key: "IdPrestcontasLrfci",
    label: "ID",
    tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
  },
  {
    key: "UsuarioEntrega",
    label: "Respons\u00E1vel",
    tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    thStyle: { minWidth: "150px" },
    sortable: true,
    formatter: defaultCPFFormatter,
    },
  {
    key: "Ano",
    label: "Ano",
    tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    thStyle: { minWidth: "70px" },
    sortable: true,
  },
  {
    key: "DeTiporelatorio",
    label: "Tipo de Relat\u00F3rio",
    tdClass: ["align-middle", "quebrarPorPalavra", "text-left", "text-xl-center"],
    thClass: ["text-center", "quebrarPorPalavra"],
    thStyle: { minWidth: "120px" },
    sortable: true,
  },
  {
    key: "DePeriodorelatorio",
    label: "Per\u00EDodo",
    tdClass: ["align-middle", "quebrarPorPalavraHard", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    thStyle: { minWidth: "90px" },
    sortable: true,
  },
  {
    key: "DataEntrega",
    label: "Data de Entrega",
    tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
    thClass: ["text-center", "quebrarPorPalavraHard"],
    thStyle: { minWidth: "120px" },
    sortable: true,
    formatter: defaultDateFormatter,
  },
  {
    key: "DsStatusPc",
    label: "Situa\u00E7\u00E3o",
    tdClass: ["align-middle", "quebrarPorPalavra", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    thStyle: { minWidth: "90px" },
    sortable: true,
  },
  {
    key: "actions",
    label: "A\u00E7\u00F5es",
    tdClass: ["align-middle", "col-actions", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
  },
];
